import styled from '@emotion/styled';

export const AcceptLineBreakText = styled.p`
  white-space: pre-wrap;
`;
